<script>
    import { onMount } from "svelte";

    import Button from "../../Components/Common/Button.svelte";
    import Input from "./components/SigninInput.svelte";

    import {
        goBack,
        goToURL,
        serverUrl,
    } from "../../Utils/utilFunctions.svelte";
    import { apiMethods } from "../../Services/index.svelte";

    import {
        createUser,
        createAccount,
        user,
        userLoginDetails,
        loggedInDoctorDetail,
    } from "../../stores";

    import { X_Device_ID } from "../../Utils/utilConstants.svelte";

    let mfaCode,
        isValidatingMFA = false,
        error;

    let showRedirectionModal = false;

    $: isSubmitDisabled = !mfaCode;

    onMount(() => {
        if (!$userLoginDetails.email || !$userLoginDetails.password) goBack();
    });

    const validateCode = async () => {
        isValidatingMFA = true;

        $userLoginDetails = { ...$userLoginDetails, mfaCode };

        await apiMethods.postMethod
            .logIn($userLoginDetails)
            .then(async (res) => {
                if (res.error && res.error?.toLowerCase() == "mfaincorrect")
                    error = "Incorrect code, please try again";
                else {
                    $user.token = res.token;
                    $user.role = res.role;

                    var requestObject = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Access-Control-Allow-Credentials": "true",
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "GET",
                            Authorization: `Bearer ${res.token}`,
                        },
                        mode: "cors",
                        cache: "no-cache",
                    };

                    requestObject.headers["X-Device-Id"] = X_Device_ID;

                    const response = await fetch(
                        `${serverUrl}/User/${res.id}`,
                        requestObject,
                    );

                    const result = await response.json();

                    // sync user settings
                    $user.settings = result.settings
                        ? JSON.parse(result.settings)
                        : {};
                    $user.groupId = result.groupId;
                    $user.groupName = result.groupName;

                    if (result.id == res.id) {
                        if (
                            res.role > 2 ||
                            (result.userAccounts &&
                                result.userAccounts.length > 1)
                        )
                            await _handleUserDetails(result);
                        else if (result.userAccounts.length == 1) {
                            const accountResponse = await fetch(
                                `${serverUrl}/Account/${result.userAccounts[0].id}`,
                                requestObject,
                            );
                            const accountResult = await accountResponse.json();

                            if (
                                accountResult.status != 0 &&
                                accountResult.status != 1
                            )
                                error =
                                    "We're still working on creating your account. Please check again later.";
                            else await _handleUserDetails(result);
                        } else await _handleUserDetails(result);
                    }
                }
            });

        isValidatingMFA = false;
    };

    const loadDoctorDetails = () => {
        apiMethods.getMethod.getAccountByUserId($user.id).then((res) => {
            $loggedInDoctorDetail = { ...res };
        });
    };

    const clearError = () => {
        error = null;
    };

    const closeRedirectionModal = () => {
        showRedirectionModal = false;

        goToURL("/");
    };

    const continueRedirection = () => {
        closeRedirectionModal();

        goToURL("/sign-up");
    };

    // HELPER FUNCTIONS
    const _handleUserDetails = async (res) => {
        if (
            ($user.role == 2 || !$user.role) &&
            (!res.verifiedEmail ||
                !res.verifiedPhone ||
                !res.userAccounts.length)
        ) {
            showRedirectionModal = true;

            $createUser = {
                ...$userLoginDetails,
                token: $user.token,
                id: res.id,
            };

            $createAccount = { ...res };

            $userLoginDetails = {};
        } else {
            await apiMethods.postMethod.logIn($userLoginDetails).then((res) => {
                if (res.id) {
                    $user.token = res.token;
                    $user.refreshToken = res.refreshToken;
                    $user.expiration = res.expiration;
                    $user.id = res.id;
                    $user.name = res.name;
                    $user.role = res.role;
                }
            });

            $userLoginDetails = {};

            if ($user.role == 2) loadDoctorDetails();

            goToURL("/");
        }
    };
</script>

<div class="flex-1 flex flex-col items-center w-full h-full p-6 showBG">
    <div class="flex items-center px-4 py-2">
        <img src="/favicon.png" alt="" class="w-[48px] h-[48px]" />
        <p class="text-primary text-2xl font-bold title-font pl-4">Anaemate</p>
    </div>

    <div class="flex flex-1 items-center justify-evenly w-full">
        <div class="artboard artboard-demo w-auto h-auto gap-4 p-6 shadow-lg">
            <div class="flex flex-col items-center">
                <p class="text-[24px] font-bold text-gray-600">
                    Please enter your one-time code
                </p>
            </div>
            <form novalidate>
                <Input
                    label="Code"
                    bind:value={mfaCode}
                    type="text"
                    inputClass="w-80"
                    autofocus
                    {error}
                    {clearError}
                    isAutoComplete="off"
                />

                {#if error}
                    <p class="errText text-error w-80 whitespace-normal py-2">
                        {error}
                    </p>
                {/if}

                <div
                    class="flex flex-1 flex-row-reverse items-center justify-between"
                >
                    <Button
                        manualClass={`min-w-[130px] btn-primary ${
                            isValidatingMFA ? "loading" : ""
                        }`}
                        clickFunc={validateCode}
                        isDisabled={isValidatingMFA || isSubmitDisabled}
                    >
                        {isValidatingMFA ? "Submitting" : "Submit"}
                    </Button>

                    <Button
                        manualClass="min-w-[130px] btn-error"
                        clickFunc={() => {
                            goToURL("/");
                        }}
                        isDisabled={isValidatingMFA}
                    >
                        Cancel
                    </Button>
                </div>
            </form>
        </div>
    </div>
</div>

<div
    class={showRedirectionModal ? "modal modal-open sm:modal-middle" : "modal"}
>
    <div class="modal-box">
        <h3 class="font-medium text-lg">Oops....</h3>
        <div class="p-4">
            <p class="leading-6 text-error whitespace-pre-line">
                Looks like you haven't finished the onboarding process. Would
                you like to continue?
            </p>
        </div>
        <div class="modal-action">
            <button
                class="btn btn-error text-white btn-sm border-none w-24"
                on:click={closeRedirectionModal}
            >
                Close
            </button>

            <button
                class="btn btn-secondary text-white btn-sm border-none w-24"
                on:click={continueRedirection}
            >
                Continue
            </button>
        </div>
    </div>
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .showBG {
        height: 100vh;
        background-image: url("/imgs/bg_signIn.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: bottom;
        background-size: contain;
    }

    .errText::before {
        content: "*";
    }
</style>
